import UserAPI from '@/app/apis/main/user/user-api.js';

export default {
	/**
	 * @param {*} userEmail
	 */
	async getLoggedInUser(userEmail) {
		return UserAPI.getLoggedInUser(userEmail);
	},

	/**
	 * @return {object} users details by userId
	 * @params userId
	 */
	async getUserDetails(userId) {
		return UserAPI.getUserDetails(userId);
	},

	/**
	 * @return {object} list of users
	 * @params queryParams
	 */
	async getUserList(queryParams) {
		return UserAPI.getUserList(queryParams);
	},

	/**
	 * @return {status} 204 - No Response
	 * @param {object} userData
	 * */
	async postAdminUser(userData) {
		return UserAPI.postAdminUser(userData);
	},

	/**
	 * @return 204
	 * @params userId
	 */
	async updateUserStatus(userId, userDetails) {
		return UserAPI.updateUserStatus(userId, userDetails)
	},
	
	/**
	 * @return 204
	 * @params {object} queryParams
	 */
	async getCustomer(queryParams) {
		return UserAPI.getCustomer(queryParams);
	},
	
	/**
	* @param {*} emailAddress
	*/
	async resendLink(emailAddress) {
		return UserAPI.resendLink(emailAddress);
	},

	/**
	 * @return {object} users details by userId
	 * @params userId
	 */
	async getUserWalkerSitterDetails(userId) {
		return UserAPI.getUserWalkerSitterDetails(userId);
	},
	/**
	 * 
	 * @param {string} userId 
	 * @param {object} walkerSitterDetails 
	 * @returns 
	 */
	async putWalkerSitterDetails(userId, walkerSitterDetails) {
		return UserAPI.putWalkerSitterDetails(userId, walkerSitterDetails);
	},

	/**
	 * Retrieves a list of store credits based on the provided query parameters.
	 *
	 * @async
	 * @function getStoreCreditList
	 * @param {Object} queryParams - The parameters to filter the store credit list.
	 * @returns {Promise<Object>} A promise that resolves to the list of store credits.
	 * @throws {Error} Throws an error if the request fails.
	 */
	async getStoreCreditList(queryParams) {
		return UserAPI.getStoreCreditList(queryParams);
	},


	/**
	 * Retrieves the store credit history for a specific user.
	 *
	 * @async
	 * @function getUserStoreCreditHistory
	 * @param {string} userId - The ID of the user whose store credit history will be fetched.
	 * @returns {Promise<Object>} A promise that resolves to the store credit history.
	 * @throws {Error} Throws an error if the request fails.
	 */
	async getUserStoreCreditHistory(userId) {
		return UserAPI.getUserStoreCreditHistory(userId);
	},

	async getUserNotesAndReminders(userId) {
		return UserAPI.getUserNotesAndReminders(userId);
	},

	async addUserNoteAndReminder(userId, noteReminderDetails) {
		return UserAPI.addUserNoteAndReminder(userId, noteReminderDetails);
	}
}